import axios from "axios";
import { pbxAuthHeader } from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_PBX_API;

class PbxService {
  // DOMAIN RELATED APIs

  // get Domain list
  async getDomainDataList(filter = "") {
    return await axios
      .get(API_URL + "pbx-app/domain" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // get Domain list
  async getDomainList(filter = "") {
    return await axios
      .get(API_URL + "pbx-app/domain" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  // get Domain Detail
  async getDomainDetailList(domain_id) {
    return await axios
      .get(API_URL + "pbx-app/domain/detail", {
        headers: pbxAuthHeader(domain_id),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  // update Domain Detail
  async updateDomainDetail(domain_id, data) {
    const response = await axios.put(API_URL + "pbx-app/domain/detail", data, {
      headers: pbxAuthHeader(domain_id),
    });
    return response.data;
  }
  // update Domain Detail
  async updateDomainStatus(domain_id, data) {
    const response = await axios.patch(
      API_URL + "pbx-app/domain/detail",
      data,
      { headers: pbxAuthHeader(domain_id) }
    );
    return response.data;
  }

  // add Domain Detail
  async addDomainDetail(data) {
    const response = await axios.post(API_URL + "pbx-app/domain", data, {
      headers: pbxAuthHeader(),
    });
    return response.data;
  }

  //delete Domain Detail
  async deleteDomain(domain_uuid) {
    const response = await axios.delete(API_URL + `pbx-app/domain/detail`, {
      headers: pbxAuthHeader(domain_uuid),
    });
    return response.data;
  }

  // PBX SERVER RELATED APIs

  // Get Pbx Server List
  getPBXServerList(filter = "") {
    return axios
      .get(API_URL + "pbx-app/pbx-server" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get Pbx Server details
  getPBXServerDetail(pbx_server_id) {
    return axios
      .get(API_URL + "pbx-app/pbx-server/" + pbx_server_id, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add Pbx Server details
  addPBXServerDetail(data) {
    return axios
      .post(API_URL + "pbx-app/pbx-server", data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  updatePBXServerDetail(pbx_server_id, data) {
    return axios
      .put(API_URL + "pbx-app/pbx-server/" + pbx_server_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  updatePBXServerStatus(pbx_server_id, data) {
    return axios
      .patch(API_URL + "pbx-app/pbx-server/" + pbx_server_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // delete Pbx Server details
  deletePBXServerDetail(pbx_server_id) {
    return axios
      .delete(API_URL + "pbx-app/pbx-server/" + pbx_server_id, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // DEVICE PROFILE RELATED APIs

  // Get Device Profile List
  getDeviceProfileList(filter = "") {
    return axios
      .get(API_URL + "pbx-app/device-profile" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Pbx Server details
  getDeviceProfileDetail(device_proofile_id) {
    return axios
      .get(API_URL + "pbx-app/device-profile/" + device_proofile_id, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add Pbx Server details
  addDeviceProfileDetail(data) {
    return axios
      .post(API_URL + "pbx-app/device-profile", data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  updateDeviceProfileDetail(device_proofile_id, data) {
    return axios
      .put(API_URL + "pbx-app/device-profile/" + device_proofile_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update Pbx Server details
  updateDeviceProfileStatus(device_proofile_id, data) {
    return axios
      .patch(API_URL + "pbx-app/device-profile/" + device_proofile_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // delete Pbx Server details
  deleteDeviceProfileDetail(device_proofile_id) {
    return axios
      .delete(API_URL + "pbx-app/device-profile/" + device_proofile_id, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // WAKEUP CALL LIST RELATED APIs

  // Get wakeup call List
  getWakeUpCallList(filter = "") {
    return axios
      .get(API_URL + "call-app/wakeup-call" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get wakeup call details
  getWakeUpCallDetail(wakeupcall_uuid) {
    return axios
      .get(API_URL + "call-app/wakeup-call/" + wakeupcall_uuid, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add new wakeup call details
  addWakeUpCall(domain_uuid, data) {
    return axios
      .post(API_URL + "call-app/wakeup-call", data, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update wakeup call details
  updateWakeUpCall(wakeupcall_uuid, data) {
    return axios
      .patch(API_URL + "call-app/wakeup-call/" + wakeupcall_uuid, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete wakeup call
  deleteWakeUpCall(domain_uuid, wakeupcall_uuid) {
    return axios
      .delete(API_URL + "call-app/wakeup-call/" + wakeupcall_uuid, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Extension List
  getExtensionListByColurm(filter, domain_uuid) {
    return axios
      .get(API_URL + `pbx-service/extension` + filter, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  getRecordingList(domain_uuid) {
    return axios
      .get(API_URL + `media/recording`, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  getRingGroupList(filter = "", domain_uuid) {
    return axios
      .get(API_URL + `call-app/ring-group` + filter, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  getCallFlowList(filter = "", domain_uuid) {
    return axios
      .get(API_URL + `call-app/call-flow` + filter, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  getIVRListByColume(filter, domain_uuid) {
    return axios
      .get(API_URL + `call-app/ivr-menu` + filter, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  getVoiceMailList(domain_uuid) {
    return axios
      .get(API_URL + `pbx-service/voicemail`, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data.result;
      });
  }

  // TRUNK GROUP RELATED APIs

  // Get trunk group list
  getTrunkGroupList(provider_id, data) {
    return axios
      .post(API_URL + "phone-service/" + provider_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // SERVER HEALTH RELATED APIs

  // Get server health list
  getServerHealthList(provider_id, data) {
    return axios
      .post(
        API_URL + "phone-service/" + "d2d9137e-553c-4a93-86df-d86a5dcc9045",
        data,
        {
          headers: pbxAuthHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // GET NUMBER TO DETAILS API

  // get full destionation details by there number
  getNumberDetails(number, domain_uuid) {
    return axios
      .get(API_URL + `call-app/get-number-to-detail?number=${number}`, {
        headers: pbxAuthHeader(domain_uuid),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get security groups
  getSecurityGroups(filter = "") {
    return axios
      .get(API_URL + "pbx-app/pbx-server" + filter, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get list for specific group id
  getSecurityGroupData(group_id) {
    return axios
      .get(API_URL + `pbx-app/aws-sg/${group_id}`, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Delete Item From Security Group List
  deleteSecurityGroupItem(item_id, data) {
    return axios
      .patch(API_URL + "pbx-app/aws-sg/" + item_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Update Item From Security Group List
  updateSecurityGroupItem(item_id, data) {
    return axios
      .patch(API_URL + "pbx-app/aws-sg/" + item_id, data, {
        headers: pbxAuthHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new PbxService();
